<template>
  <div class="container">
    <div class="commercial">
      <div class="iframe-menu" v-if="showFrame">
        <iframe id="iquenda" ref="quenda" :src="quendaSrc"></iframe>
      </div>
      <div class="commercial__content" v-else>
        <div class="customer-slider" v-if="slidesFiltered">
          <div v-if="!showMap" class="customer-slider__text">
            <p class="customer-slider__text--title">
              {{
                slidesFiltered.filter
                  ? $t(slidesFiltered.filter.subtitle)
                  : $t('customer-slider.copy-less10-hidden-procedure')
              }}
            </p>
            <p v-if="tramiteDesconocido" class="customer-slider__text--hint">
              {{ $t('customer-slider.unknown-hint', { ref: tramiteDesconocido }) }}
            </p>
          </div>
        </div>
        <div class="turn" v-if="!showFrame && showTime">
          <div class="turn__detail">
            <div class="turn__detail__text">
              <div class="turn__detail__text--subtitle">
                {{ $t('turn.subtitle') }}
              </div>
            </div>
            <div class="turn__detail__time">{{ tme }} min</div>
          </div>
        </div>
        <div class="customer-map" v-if="showMap">
          <CustomerMap :mapOptions="slidesFiltered" :imageMap="imageMapName" />
        </div>
        <div class="appointment-label">
          <div class="appointment-label__wrap" @click="goAppointment()">
            <template v-if="showAppointment">
              <img
                src="@/assets/img/calendar.png"
                class="appointment-label__wrap__calendar"
              />
              <p class="appointment-label__wrap__text">
                {{ $t('turn.appointment') }}
              </p>
            </template>
            <template v-else>
              <img
                src="@/assets/img/calendar.png"
                class="appointment-label__wrap__calendar"
              />
              <p class="appointment-label__wrap__text">
                {{ $t('turn.new-turn') }}
              </p>
            </template>
          </div>
          <img
            src="@/assets/img/chevron-right.png"
            class="appointment-label__greater"
          />
        </div>
        <div class="customer-info" v-if="slidesFiltered && tme > 10">
          <IntroTitle
            :title="$t('commercial.info.title')"
            :subtitle="$t('commercial.info.subtitle')"
            padding="0px"
            gap="5px"
            titleFontSize="1.5vw"
            subtitleFontSize="14px"
            subtitleColor="#86888C"
            subtitleLineHeight="20px"
            descriptionAlign="initial"
            backgroundColor="#FFFFFF"
            id="customer-title-info"
          />
        </div>
        <div class="customer-slider" v-if="slidesFiltered && tme > 10">
          <Slider
            :pagination="true"
            cardHeight="auto"
            :bound="false"
            :circular="true"
            :align="'center'"
            :map="true"
            heightViewport="305px"
            heightCamera="auto"
            paginationBottom="0px"
          >
            <template #content>
              <div
                class="card-slide"
                width="100%"
                v-for="card in slidesFiltered.filter.experiencesList"
                :key="card.title"
              >
                <Card
                  :width="'300px'"
                  :height="'100%'"
                  :imageHeight="'145px'"
                  :image="'img/' + card.image"
                  :title="$t(card.title)"
                  :subtitle="$t(card.description)"
                  @click="$router.push(card.goTo)"
                />
              </div>
            </template>
          </Slider>
          <!--CustomSlider v-if="showCustomerSlider" :slides="slidesFiltered" /-->
        </div>
      </div>
      <div class="commercial__book">
        <button
          v-if="!showFrame"
          class="button-primary"
          @click="router.push('/')"
        >
          {{ $t('buttons.goHome') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { onMounted, ref, computed } from 'vue'
  import { useStore } from 'vuex'
  import router from '@/router'
  import i18n from '@/plugins/i18n'

  import commonMethods from '@/commonMethods'
  import saveQuendaTurn from '@/plugins/saveQuendaTurn'
  import CustomSlider from '@/components/movistar/common/CustomSlider.vue'
  import CustomerMap from '@/components/movistar/common/CustomerMap.vue'
  import Slider from '@/components/movistar/common/Slider.vue'
  import CardIntro from '@/components/movistar/cards/CardIntro.vue'
  import Card from '@/components/movistar/cards/Card.vue'
  import CardSelection from '@/components/movistar/cards/CardSelection.vue'
  import IntroTitle from '@/components/movistar/common/IntroTitle.vue'
  import mainMessageMethodListener from '@/plugins/listenerMessageMethod'

  import { watch } from 'vue'

  let procedure = router.currentRoute.value.query.procedure || 'visible'

  const store = useStore()
  const FingerprintJS = require('@fingerprintjs/fingerprintjs')
  const fpPromise = FingerprintJS.load()
  const { registerError } = commonMethods()
  const { t, locale } = i18n.global

  /*
   * Con «?quenda=emulador» en la direccion, el marco carga el emulador en vez
   * de Quenda. Sirve para probar la pantalla de despues -la espera, el mapa, el
   * registro del turno- sin sacar un turno de verdad en la tienda, que sale en
   * la pantalla de alguien que esta trabajando.
   *
   * No es un agujero: la direccion del emulador NO LA PONE QUIEN NAVEGA, sale
   * de una variable del build que solo existe si se construyo con
   * CON_EMULADOR=1. En produccion no esta, y entonces el parametro no hace
   * absolutamente nada.
   */
  const EMULADOR_DE_QUENDA = process.env.VUE_APP_QUENDA_EMULADOR
  const conEmulador =
    !!EMULADOR_DE_QUENDA &&
    router.currentRoute.value.query.quenda === 'emulador'

  const quendaSrc = conEmulador
    ? `${EMULADOR_DE_QUENDA}?tramite=${encodeURIComponent(
        procedure
      )}&store=flagship&idioma=${locale.value}`
    : `${
        process.env['VUE_APP_QUENDA_' + procedure.toUpperCase()]
      }&store=flagship&idioma=${locale.value}`

  let fbToken = computed(() => store.state.session.fbToken)
  let slides = computed(() => store.state.common.experienceSlides)
  let storeId = computed(() => store.state.common.storeId)
  let codeTransaction = computed(() => store.getters['getCodeTransaction'])
  let place = computed(() => store.getters['getPlace'])

  let tme = computed(() => store.getters['getTme'])
  // El codigo que vino sin configurar, si vino alguno. Se ensena en la
  // pantalla de espera como pista discreta: sin el no hay forma de saber que
  // tramite hay que dar de alta, porque el fallo no deja rastro en ningun log.
  let tramiteDesconocido = ref(null)
  let showFrame = ref(place.value ? false : true)
  let showTime = ref(place.value ? false : true)
  let slidesRef = ref(null)
  let showMap = ref(place.value ? true : false)
  let showCustomerSlider = ref(false)
  let showAppointment = ref(false)
  let slidesFiltered = ref({})
  let imageMapName = computed(() => store.getters['getImageMapPlace'])

  const showNotificationPlace = () => {
    showTime.value = false
    showAppointment.value = false

    if (!slidesFiltered.value.filter) {
      slidesFiltered.value.filter = {}
    }
    slidesFiltered.value.filter = {}
    slidesFiltered.value.filter.subtitle =
      t('customer-slider.waitIn') + place.value
    showMap.value = true
    showCustomerSlider.value = false
    if (imageMapName.value) {
      if (imageMapName.value.includes('map0'))
        slidesFiltered.value.filter.floor = t('home.map.tabs.tab-0.title')
      else if (imageMapName.value.includes('map1'))
        slidesFiltered.value.filter.floor = t('home.map.tabs.tab-1.title')
    }
  }

  if (place.value) {
    showNotificationPlace()
  }

  watch(place, (newVal) => {
    if (newVal) showNotificationPlace()
  })

  const goTo = (type) => {
    router.push({ path: type })
  }

  const goAppointment = async () => {
    showFrame.value = true
    showAppointment.value = false
    showMap.value = false
    showCustomerSlider.value = false
  }

  const calculateSlides = async (time, s) => {
    let t = parseInt(time)
    const ALIAS_DE_TRAMITE = { C: 'TC', G: 'TG' }
    const codigo =
      ALIAS_DE_TRAMITE[codeTransaction.value] ?? codeTransaction.value

    /*
     * Y el catalogo puede no haber llegado todavia. `experienceSlides`
     * nace valiendo {} -no una lista- y solo se rellena DENTRO de
     * `getDeviceInfo`, o sea detras de una llamada de red. Si el turno
     * llega antes de que vuelva, o si esa llamada fallo, `.find` revienta,
     * el manejador se corta y LA PANTALLA SE QUEDA SIN REACCIONAR: el
     * visitante ha cogido su turno y sigue viendo el marco.
     *
     * Tratarlo como catalogo vacio lo manda al respaldo de abajo, que es
     * exactamente lo que hay que ensenar: su turno, con su espera, sin el
     * contenido especifico que no se ha podido cargar.
     */
    const catalogo = Array.isArray(slides.value) ? slides.value : []
    let sl = catalogo.find((slide) => slide.code == codigo)
    //let sl = s.value.find((slide) => slide.code == codeTransaction.value)

    if (sl) {
      slidesFiltered.value.code = sl.code

      if (t >= 0 && t < 10) {
        slidesFiltered.value.filter = sl.less10
        showCustomerSlider.value = sl.less10.experiences
        showMap.value = false
        showAppointment.value = sl.less10?.appointment
        console.log(slidesFiltered.value)
        //less10
      } else if (t >= 10 && t < 30) {
        slidesFiltered.value.filter = sl.to30
        showCustomerSlider.value = sl.to30.experiences
        showAppointment.value = sl.to30?.appointment
        console.log(slidesFiltered.value)
        //10to30
      } else if (t >= 30) {
        slidesFiltered.value.filter = sl.more30
        showCustomerSlider.value = sl.more30.experiences
        showAppointment.value = sl.more30?.appointment
        console.log(slidesFiltered.value)
        //more45
      }
    } else {
      // Sin cola que case, antes se quedaba en blanco. Ahora sale la
      // confirmacion generica, que es verdad -el turno SI se ha cogido- y
      // se recuerda el codigo para poder decir cual vino sin configurar.
      // La pista solo si el catalogo SI llego y el codigo no estaba en el:
      // cuando lo que falta es el catalogo entero, el tramite no tiene la
      // culpa y decir «no hemos podido calcular el tiempo para este tramite»
      // manda a quien lo lea a buscar donde no es.
      tramiteDesconocido.value = catalogo.length ? codeTransaction.value : null
      slidesFiltered.value.code = codeTransaction.value
      slidesFiltered.value.filter = {
        subtitle:
          t < 10
            ? 'customer-slider.copy-less10-hidden-procedure'
            : t < 30
              ? 'customer-slider.copy-to30-hidden-procedure'
              : 'customer-slider.copy-more30-hidden-procedure',
        experiences: false,
      }
      showCustomerSlider.value = false
      showAppointment.value = false
      showMap.value = false
    }

    if (place.value) {
      showNotificationPlace()
    }
  }

  onMounted(() => {
    store.commit('setGoAppointmentVar', false)
    slidesRef.value = slides.value
    if (tme.value) {
      calculateSlides(tme.value, slidesRef)
      showFrame.value = false
    }
    window.addEventListener(
      'message',
      async (event) => {
        try {
          console.log('In CommercialView window.addEventListener')
          console.log(event.data)
          const origenesDeFiar = [
            window.location.origin,
            new URL(quendaSrc, window.location.origin).origin,
          ]

          const oData = origenesDeFiar.includes(event.origin)
            ? JSON.parse(event.data)
            : {}
          if (oData.tme) {
            store.dispatch('updateTme', oData.tme)
            await store.dispatch('updateCodeTransaction', oData.codTramite)
            await calculateSlides(oData.tme, slidesRef)
            showFrame.value = false
            showMap.value = false
            store.commit('setPlace', null)
            store.commit('setImageMapPlace', null)

            // Get the visitor identifier when you need it.
            const fp = await fpPromise
            const result = await fp.get()

            saveQuendaTurn(
              oData.idCita,
              fbToken.value,
              result.visitorId,
              storeId.value,
              oData.alias,
              oData.telefono
            )
          } else if (oData.action) {
            if (oData.action === 'showCommercial') {
              showFrame.value = false
              /*
               * Escribia en `slidesFiltered.subtitle`, UNA PROPIEDAD QUE NADIE
               * PINTA: la plantilla lee `slidesFiltered.filter.subtitle`. O
               * sea que el marco se escondia y en su sitio no salia nada,
               * nunca, desde siempre.
               *
               * La forma buena ya estaba doce lineas mas arriba, en
               * `showNotificationPlace()`, que ademas pinta el plano y la
               * planta. Se llama a esa en vez de repetirla mal: asi el aviso
               * de sala se ve igual venga de donde venga.
               */
              store.commit('setPlace', oData.place)
              showNotificationPlace()
            }
          }
        } catch (err) {
          registerError(err)
        }
        mainMessageMethodListener(event)
      },
      false
    )
  })
</script>

<style lang="scss" scoped>
  @import '@/scss/mixings';

  .commercial {
    @include d-flex(column, flex-start, center);
    gap: 3vh;
    height: 100%;
    overflow-y: auto;
    &__content {
      @include d-flex(column, flex-start, center);
      gap: 3dvh;
      width: 100%;
      margin-bottom: 120px;
    }
    &__book {
      @include d-flex(row, center, center);
      gap: 0px;
      width: 100%;
      height: 96px;
      padding: 0 20px;
      background-color: #fff;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
      border-top: 1px #f6f6f6 solid;
      position: fixed;
      z-index: 1;
      bottom: 0px;
    }
  }
  .iframe-menu {
    @include d-flex(column, flex-start, center);
    height: 100%;
    width: 100%;
    margin-bottom: 120px;

    #iquenda {
      width: 100%;
      height: 100%;
      border: 0;
    }
  }
  .turn {
    width: 100%;
    align-self: center;
    &__detail {
      @include d-flex(column, center, center);
      gap: 3vh;
      padding: 5.5vw;
      border-radius: 0.5rem;
      background: $primary;
      font-family: 'OnAir';
      &__text {
        @include d-flex(column, center, center);
        gap: 1vh;
        color: var(--primary-grey-color);
        &--title {
          font-size: var(--fs-large);
          font-weight: var(--fw-medium);
          line-height: 24px;
        }
        &--subtitle {
          font-size: var(--fs-large);
          line-height: 24px;
        }
      }
      &__time {
        font-size: 3rem;
        font-weight: var(--fw-bold);
        line-height: 56px;
      }
      &--buttons {
        @include d-flex(column, center, center);
        gap: 1.87vh;
        font-size: 3.223vw;
        font-weight: var(--fw-medium);
      }
      &--location {
        @include d-flex(row, center, center);
        gap: 1.54vw;
        padding: 1.12vh 3.33vw;
        border: 1px solid $primary-70;
        border-radius: 0.25rem;
        color: $primary-70;
        background: $white;
      }
      &--cancel {
        padding: 0.73vh 9.05vw;
        color: $primary-70;
        text-decoration: underline;
      }
    }
  }
  .experiences {
    padding: 0 2.56vw;
    &__detail {
      @include d-flex(column, center, center);
      gap: 3.85vw;
      &--info {
        @include d-flex(column, center, center);
      }
      &--title {
        font-size: 3.33vw;
        font-weight: var(--fw-medium);
      }
      &--subtitle {
        font-size: 2.76vw;
      }
      &--list {
        @include d-flex(row, flex-start, center);
        gap: 1.87vh;
        width: 100%;
        overflow-x: auto;
        font-size: 2.76vw;
        &--experience {
          @include d-flex(row, center, center);
          gap: 1.25vh;
          padding: 3.85vw;
          min-width: 58.2vw;
          height: 13vh;
          border: 1px solid $primary-60;
          border-radius: 0.5rem;
        }
        &--image {
          width: 16.15vw;
          height: 9.25vh;
          border-radius: 0.5rem;
          font-size: 2.76vw;
        }
        &--text {
          @include d-flex(column, center, flex-start);
          width: auto;
          font-size: 2.56vw;
          &--title {
            font-weight: var(--fw-medium);
          }
        }
      }
    }
  }
  .customer-slider {
    @include d-flex(column, center, flex-start);
    width: 100%;
    gap: 2vh;
    &__text {
      @include d-flex(column, center, flex-start);
      gap: 0.5vh;
      &--title {
        font-family: 'OnAir';
        font-size: var(--fs-xx-large);
        font-weight: var(--fw-bold);
        line-height: 32px;
        color: var(--primary-grey-color);
      }
      &--subtitle {
        font-family: 'OnAir';
        font-size: var(--fs-xx-large);
        line-height: 32px;
        font-weight: 700;
        color: var(--secondary-grey-color);
      }
    }
  }
  .customer-map {
    @include d-flex(column, center, center);
    width: 100%;
  }
  .appointment-label {
    @include d-flex(row, space-between, center);
    padding: 3vh 5vw;
    width: 100%;
    border: 1px solid #dddddd;
    border-radius: 0.7rem;
    &__wrap {
      @include d-flex(row, flex-start, center);
      gap: 4vw;
      &__text {
        line-height: 24px;
        color: #0b2739;
      }
    }

    &__greater {
      color: #dddddd;
    }
  }
  .hidden {
    display: none;
  }
  .card-slide {
    padding-bottom: 0px;
  }
</style>
